import React from 'react'

const Brand = () => {
    return (
        <img
            src={`${process.env.PUBLIC_URL}/images/header-logo.png`}
            width="50.28"
            height="57.11"
            alt='logo'
        />
    )
}

export default Brand